import api from 'state/axios';

export const getFiles = (path, search) => api.get('/files', { params: { path, search } });
export const uploadFile = (file, path) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('path', JSON.stringify(path));
  return api.post('/files/upload', formData);
};
export const createFolder = (name, path) => api.post('/files/folder', { name, path });
export const renameFile = (id, name) => api.put(`/files/${id}`, { name });
export const deleteFiles = (ids) => api.delete('/files', { data: { ids } });
export const moveFiles = (ids, newPath) => api.post('/files/move', { ids, newPath });
export const downloadFile = (id) => api.get(`/files/download/${id}`, { responseType: 'blob' });
export const downloadFolder = (id) => api.get(`/files/download/folder/${id}`, { responseType: 'blob' });
export const previewFile = (id) => api.get(`/files/preview/${id}`, { responseType: 'blob' });
